import { v4 as uuidv4 } from 'uuid';
//////////////////////////////////////////////////

const generateUuid = () => uuidv4();

export {
  generateUuid,
};
